import type { DisplayOptions, FacetOptions } from '../types';

export const appOptions: { display: DisplayOptions; itemsPerPage: number } = {
  display: {
    searchFacets: true,
    searchQuery: true,
    resultCount: true,
    searchSort: true
  },
  itemsPerPage: 50
};

export const facetOptions: { options: FacetOptions } = {
  options: {
    useAnd: false,
    persistCounts: false,
    display: {
      count: true
    }
  }
};
